// ============================================================================
// Modus-Entscheidung fuer ein 'undecided'-Listing (listing-detail-pane.ts).
// Bewusst DB- und DOM-frei, damit die Regel testbar ist -- gleiches Muster wie
// publish-button.ts und produktstand.ts.
//
// Anlass (2026-08-23): Der Listing-Modus wird nicht mehr von der EAN entschieden,
// sondern vom Haendler (Migration 0058, kaufland_set_listing_mode). Ein per MCP
// provisioniertes Listing kommt als mode='undecided' an und darf nicht gepusht
// werden, bis der Haendler im Lister waehlt.
// ============================================================================

export interface ModusWahl {
  attachMoeglich: boolean;
  grundWennNicht: string | null;
}

/**
 * Aufschalten braucht ein Kaufland-Produkt, an das die Unit gehaengt wird. Ohne
 * `attach_id_product` ist nur Neu-Listen moeglich -- und der Haendler soll den Grund
 * lesen koennen, statt eine ausgegraute Schaltflaeche zu deuten.
 *
 * Fix (Review 2026-08-24, im Rahmen von Task 7's Sammelaktion gefunden): der Grundtext
 * behauptete vorher eine Ursache ("Zu dieser EAN gibt es kein Kaufland-Produkt"), die nicht
 * immer stimmt. `attach_id_product` ist auch dann leer, wenn eine FRUEHERE 'new'-Entscheidung
 * es genullt hat (kaufland_set_listing_mode, 0058) und das Listing anschliessend per
 * Re-Provisionierung wieder auf 'undecided' zurueckfiel -- es gab also durchaus einen
 * Katalogtreffer, nur ist die Spalte jetzt trotzdem leer. Der Text nennt jetzt den ZUSTAND,
 * genau wie die RPC es in ihrer eigenen Fehlermeldung tut ("ist aktuell kein
 * Kaufland-Katalogprodukt hinterlegt"), statt eine Ursache zu vermuten.
 */
export function bestimmeModusWahl(attachIdProduct: number | null | undefined): ModusWahl {
  if (attachIdProduct === null || attachIdProduct === undefined) {
    return {
      attachMoeglich: false,
      grundWennNicht:
        'Für dieses Angebot ist aktuell kein Kaufland-Katalogprodukt hinterlegt '
        + '(attach_id_product ist leer). Aufschalten braucht eines — hier ist nur '
        + 'Neu-Listen moeglich.',
    };
  }
  return { attachMoeglich: true, grundWennNicht: null };
}
